import 'slick-carousel/slick/slick'

export default class CaseStudyTeamSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-case-study-team-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                arrows: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: true,
                adaptiveHeight: true,
                appendDots: $('.js-case-study-team-slider-dots'),

                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        }

    }

};

new CaseStudyTeamSlider();
